import { render, staticRenderFns } from "./CardBanner.vue?vue&type=template&id=79007322&scoped=true"
import script from "./CardBanner.vue?vue&type=script&lang=ts"
export * from "./CardBanner.vue?vue&type=script&lang=ts"
import style0 from "./CardBanner.vue?vue&type=style&index=0&id=79007322&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79007322",
  null
  
)

export default component.exports